import React, { createContext, useContext, useEffect } from 'react';
import api from './api';
import { useAuth } from './auth';
import { useStore } from '../store/useStore';

const PresenceCtx = createContext(null);

export function PresenceProvider({ children }) {
  const { user } = useAuth();
  const { presence: statuses, setAllPresence, setPresence } = useStore();

  const changeStatus = async (presence_status, custom_status_msg = null) => {
    try {
      await api.post('/chat/users/status', { presence_status, custom_status_msg });
      // Update local store state immediately
      if (user) {
        setPresence(user.id, presence_status, custom_status_msg);
      }
    } catch (e) {
      console.error('Failed to change user status', e);
    }
  };

  // Fetch initial statuses when user logs in
  const loadStatuses = async () => {
    if (!user) return;
    try {
      const { data } = await api.get('/team');
      const initial = {};
      data.members.forEach(m => {
        initial[m.id] = {
          presence_status: m.presence_status || 'offline',
          custom_status_msg: m.custom_status_msg || null,
          full_name: m.full_name,
          avatar_color: m.avatar_color
        };
      });
      setAllPresence(initial);
    } catch (e) {
      console.error('Failed to load initial team statuses', e);
    }
  };

  useEffect(() => {
    if (user) {
      changeStatus('online');
    }
    loadStatuses();
  }, [user]);

  return (
    <PresenceCtx.Provider value={{ statuses, changeStatus }}>
      {children}
    </PresenceCtx.Provider>
  );
}

export const usePresence = () => useContext(PresenceCtx);
